// @ts-nocheck -- stub for water builds where @ecolab/mfe.services is not installed.
// Replaces `mfe-services-adapter.ts` via `angular.json` `fileReplacements`.
import { signal } from '@angular/core';

export function getShellUserStore(): { userDetails: () => unknown } | null {
  return { userDetails: signal(null) };
}
